
import logoAnimated from 'Assets/Icons/logo-animated.svg';
import Button from 'Components/Atoms/Button/Button';
import { Helmet } from 'react-helmet-async';
import styles from './NoRolePage.module.sass';

export const NoRolePage = () => {
    return <>
        <Helmet>
            <title>Geen rechten - App Growing People B.V.</title>
        </Helmet>

        <div className={styles.container}>
            <img src={logoAnimated} width="300px" />

            <div className={styles.message_container}>
                <div className={styles.message}>Je hebt nog geen rechten in het systeem.</div>
                <div className={styles.submessage}>Vraag aan de Systeem Beheerder om rechten en probeer later nog een keer.</div>
            </div>

            <Button
                variant='transparent'
                color='primary'
                onClick={() => window.location.reload()}
            >
                Refresh pagina
            </Button>
        </div>
    </>;
}

export default NoRolePage;